<template>
  <el-dialog
      :close-on-click-modal="false"
    title="操作原因"
    :visible.sync="passblock"
    :modal-append-to-body="false"
    width="45%"
    :before-close="handleClose"
  >
    <avue-form ref="passdata" v-model="passdata" :option="option0" @submit="passcheck">
      <!-- <template slot="menuForm">
        <div class="passblocksblock">
          <el-button @click="passblock = false">取 消</el-button>
          <el-button type="primary" @click="passcheck">确 定</el-button>
        </div>
      </template> -->
    </avue-form>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      passblock: false,
      passdata: {
        id: "",
        advise: "",
        pass: false
      },
      type: "",
      option0: {
        emptyBtn: false,
        // submitBtn: false,
        column: [
          {
            label: "原因描述",
            prop: "advise",
            type: "textarea",
            minRows: 4,
            maxlength: 200,
            span: 24,
            rules: [
              {
                required: true,
                message: "请输入原因",
                trigger: "blur"
              }
            ]
          }
        ]
      }
    };
  },
  props: {
    passdata: Array
  },
  methods: {
    showblock(type) {
      this.passblock = true;
      this.passdata.advise = "";
      this.type = type;
      if (type == true) {
        this.passdata.pass = true;
      } else {
        this.passdata.pass = false;
      }
    },
    passcheck(form,down) {
      this.$refs.passdata.validate(vaild => {
        if (vaild) {
          // 
          // console.log(this.passdata);
          this.$emit("passcheck", this.passdata, this.type);
          this.passblock = false;
          down()
        }
      });
    }
  }
};
</script>

<style></style>
